<script>
    import { createEventDispatcher } from 'svelte';
    import MultiFieldProInput from './MultiFieldProInput.svelte';
    import MultiFieldProAsset from './MultiFieldProAsset.svelte';

    export let mtappVars;
    export let id;
    export let storage;
    export let storageKey;
    export let handle;
    export let fieldBlocks;

    const dispatch = createEventDispatcher();
    function triggerInputChange() {
        dispatch('inputchange');
    }
</script>

<div data-handle={handle}>
    {#if fieldBlocks[handle].description}
        <p class="mtapp-mf-description mt-2 mb-0">
            <small>
                {@html fieldBlocks[handle].description}
            </small>
        </p>
    {/if}
    {#each fieldBlocks[handle].fields as handleInFields}
        <div class="mb-5">
            <div>
                <div class="mb-3 fw-bold">
                    {fieldBlocks[handleInFields].label}
                    {#if fieldBlocks[handleInFields].required}
                        <span class="badge badge-danger">{mtappVars.translate['Required']}</span>
                    {/if}
                </div>
                {#if fieldBlocks[handleInFields].description}
                    <div class="mb-3">{fieldBlocks[handleInFields].description}</div>
                {/if}
            </div>
            {#if ['text', 'email', 'url', 'tel', 'password', 'number', 'datepicker', 'date', 'time', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'textarea', 'code', 'tinymce', 'select', 'select-multiple', 'checkbox', 'radio'].includes(fieldBlocks[handleInFields].type)}
                <MultiFieldProInput
                    mtappVars={mtappVars}
                    id={`${id}-${handleInFields}`}
                    storage={storage[storageKey]}
                    storageKey={handleInFields}
                    handle={handleInFields}
                    fieldBlock={fieldBlocks[handleInFields]}
                    on:inputchange={triggerInputChange} />
            {:else if ['asset', 'image'].includes(fieldBlocks[handleInFields].type)}
                <MultiFieldProAsset
                    mtappVars={mtappVars}
                    id={`${id}-${handleInFields}`}
                    storage={storage[storageKey]}
                    storageKey={handleInFields}
                    handle={handleInFields}
                    fieldBlock={fieldBlocks[handleInFields]}
                    on:inputchange={triggerInputChange} />
            {/if}
        </div>
    {/each}
</div>
